import React from 'react';
import './show-more.scss';

export default class ShowMore extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false,
            fade: 'show-more--fade'
        };
    }

    expand = () => {
        this.setState({
            isExpanded: true,
            fade: ''
        });
    };

    render() {
        const { isExpanded, fade } = this.state;
        const { children } = this.props;

        return (
            <div className={`show-more ${fade}`}>
                {children}
                {!isExpanded && (
                    <div className="show-more__gradient position-absolute text-center text-lg-left m-0 w-100">
                        <div onClick={this.expand}>
                            Visa mer
                            <svg
                                className="icon icon-sm ml-2"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 34 34">
                                <path d="M31.858 9.967l-14.372 16.8A.634.634 0 0 1 17 27c-.231 0-.393-.078-.486-.233L2.142 9.967c-.162-.178-.185-.39-.07-.634A.583.583 0 0 1 2.628 9h28.744c.255 0 .44.111.556.333.115.245.092.456-.07.634z" />
                            </svg>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
